import dayjs from 'dayjs';
import React, { useState } from 'react';

//Componentes
import SettingsLogsContainer from '../../components/settingsLogs/SettingsLogsContainer';

//Estilos
import './Settings.css';

function Settings({ functions, states }) {
    const {
        register,
        handleSubmit,
        formState: { errors },
        onSubmit,
        setWatchLogs,
        onArcGisSync,
    } = functions;

    const {
        settings,
        months,
        InitialDays,
        FinalDays,
        vendimiaDays,
        watchLogs,
    } = states;

    return (
        <div className="settings-container">
            <h3 className="settings-title">Ajustes del Sistema</h3>
            <form className="settings-form" onSubmit={handleSubmit(onSubmit)}>
                <h4 className="settings-subtitle">
                    Rango de Zafra de Declaración Jurada de Cosecha Probable
                </h4>
                <section className="settings-section">
                    <label className="settings-label">
                        <span>Inicio: </span>
                        <select {...register('mes_rango_DJCP_inicio')}>
                            {months.map((m, i) => {
                                return (
                                    <option key={m + i} value={i + 1}>
                                        {m}
                                    </option>
                                );
                            })}
                        </select>
                        <select {...register('dia_rango_DJCP_inicio')}>
                            {InitialDays?.map((d, i) => {
                                return (
                                    <option key={i} value={d}>
                                        {d}
                                    </option>
                                );
                            })}
                        </select>
                    </label>
                    <label className="settings-label">
                        <span>Fin: </span>
                        <select {...register('mes_rango_DJCP_fin')}>
                            {months.map((m, i) => {
                                return (
                                    <option key={m + i} value={i + 1}>
                                        {m}
                                    </option>
                                );
                            })}
                        </select>
                        <select {...register('dia_rango_DJCP_fin')}>
                            {FinalDays?.map((d, i) => {
                                return (
                                    <option key={i} value={d}>
                                        {d}
                                    </option>
                                );
                            })}
                        </select>
                    </label>
                </section>
                <h4 className="settings-subtitle">Cierre de Vendimia</h4>
                <section className="settings-section">
                    <label className="settings-label">
                        <span>Mes: </span>
                        <select {...register('mes_vendimia_inicio')}>
                            {months.map((m, i) => {
                                return (
                                    <option key={m + i} value={i + 1}>
                                        {m}
                                    </option>
                                );
                            })}
                        </select>
                        <span>Día: </span>
                        <select {...register('dia_vendimia_inicio')}>
                            {vendimiaDays?.map((d, i) => {
                                return (
                                    <option key={i} value={d}>
                                        {d}
                                    </option>
                                );
                            })}
                        </select>
                    </label>
                </section>
                <h4 className="settings-subtitle">Fecha Limite para DJCE</h4>
                <section className="settings-section">
                    <label className="settings-label">
                        <span>Mes: </span>
                        <select {...register('mes_djce_fecha_limite')}>
                            {months.map((m, i) => {
                                return (
                                    <option key={m + i} value={i + 1}>
                                        {m}
                                    </option>
                                );
                            })}
                        </select>
                        <span>Día: </span>
                        <select {...register('dia_djce_fecha_limite')}>
                            {vendimiaDays?.map((d, i) => {
                                return (
                                    <option key={i} value={d}>
                                        {d}
                                    </option>
                                );
                            })}
                        </select>
                    </label>
                </section>
                <h4 className="settings-subtitle">
                    Sincronización con Registros ArcGis
                </h4>
                <section className="settings-section">
                    <label className="settings-label">
                        <span>Ultima Sincronización: </span>
                        <p>
                            {dayjs(settings.djcp_Sync_fin).format(
                                'DD-MM-YYYY HH:mm'
                            )}
                        </p>
                    </label>
                    <label className="settings-label">
                        <span>Tiempo Insumido: </span>
                        <p>
                            {`${Math.ceil(
                                (new Date(settings.djcp_Sync_fin).getTime() -
                                    new Date(
                                        settings.djcp_Sync_ini
                                    ).getTime()) /
                                    1000
                            )} s`}
                        </p>
                    </label>
                    <button
                        className="btn btn-primary"
                        onClick={() => onArcGisSync()}
                    >
                        Sincronizar
                    </button>
                </section>
                <footer className="settings-footer">
                    <button className="btn btn-primary">Guardar</button>
                </footer>
                <section className="settings-section">
                    <h4 className="profile-title">Ver Historial</h4>
                    <button
                        className="btn btn-primary profile-history_btn"
                        type="button"
                        onClick={() => setWatchLogs(!watchLogs)}
                    >
                        {!watchLogs ? 'Ver Historial' : 'Ocultar Historial'}
                    </button>
                    {watchLogs && <SettingsLogsContainer />}
                </section>
            </form>
        </div>
    );
}

export default Settings;
